// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import DropDown from '../DropDown'
import Menu from './Menu'

const DatabaseManagement = () => (
  <DropDown
    idRoot={'header-database-management-menu'}
    Header={'Databases'}
    Menu={Menu} />
)

export default DatabaseManagement
